import {
  DataTable,
  DateField,
  NeutralBadge,
  NumberField,
  ReferenceField,
  Show,
  TextField,
} from "../../common";
import { ReferenceManyField } from "@/components/admin";
import { ProcessPayrollButton } from "./ProcessPayrollButton";

export const PayrollRunShow = () => (
  <Show actions={<ProcessPayrollButton />}>
    <div className="flex flex-col gap-6">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4 rounded-md border p-4">
        <div>
          <div className="text-xs text-muted-foreground">Month</div>
          <DateField source="period_month" />
        </div>
        <div>
          <div className="text-xs text-muted-foreground">Status</div>
          <NeutralBadge />
        </div>
        <div>
          <div className="text-xs text-muted-foreground">Employees</div>
          <NumberField source="employee_count" />
        </div>
        <div>
          <div className="text-xs text-muted-foreground">Gross</div>
          <NumberField
            source="total_gross"
            options={{ style: "currency", currency: "INR" }}
          />
        </div>
        <div>
          <div className="text-xs text-muted-foreground">Net</div>
          <NumberField
            source="total_net"
            options={{ style: "currency", currency: "INR" }}
          />
        </div>
      </div>
      <div className="pt-4">
        <ReferenceManyField
          reference="hr_payroll_slips"
          target="run_id"
          label={false}
        >
          <DataTable rowClick="show">
            <DataTable.Col label="Employee">
              <ReferenceField
                source="employee_id"
                reference="employees"
                link={false}
              >
                <TextField source="name" className="font-semibold" />
              </ReferenceField>
            </DataTable.Col>
            <DataTable.Col source="gross" label="Gross">
              <NumberField
                source="gross"
                options={{ style: "currency", currency: "INR" }}
              />
            </DataTable.Col>
            <DataTable.Col source="deductions" label="Deductions">
              <NumberField
                source="deductions"
                options={{ style: "currency", currency: "INR" }}
              />
            </DataTable.Col>
            <DataTable.Col source="net" label="Net" className="text-success font-semibold">
              <NumberField
                source="net"
                options={{ style: "currency", currency: "INR" }}
              />
            </DataTable.Col>
            <DataTable.Col source="present_days" label="Present" />
            <DataTable.Col source="leave_days" label="Leave" />
          </DataTable>
        </ReferenceManyField>
      </div>
    </div>
  </Show>
);

